
import http from '@/components/services/http-common';

 class EmployeeApi {
  get = (month) => {
    return http.get('monthlyTimesheets/employee-info?date='+month).then(r => {
      return r.data
    })
  }

  set = (month) => {
    return http.post('monthlyTimesheets/employee-info?date='+month).then(r => {
      return r.data
    })
  }

  reset = (month) => {
    return http.delete('monthlyTimesheets/employee-info?date='+month).then(r => {
      return r.data
    })
  }
  
}
export default new EmployeeApi